<template>
	<div  class="testmove" ref="someTarget">
			<movable  class="modaltitle " target="someTarget" posTop="400" posLeft="400"  :bounds="{y:[-140,520]}"  >{{callData.ProspName}}</movable>
			<div class="calling_wrapper" >
				<div class="calling-container">
					<div class="calling_rightside">
						<div class="d-flex align-center" style="align-items:center;width: 100%; justify-content: flex-end;">
							<div class="calling_icons">
								<div><button v-if="!muted" class="mic_btn" type="button"  @click="toggleMute" >
									<v-icon name="microphone" scale="2" class="text-blue" />
								</button>
								<button v-if="muted" class="mic_btn_mute" type="button"    @click="toggleMute">
									<v-icon name="microphone-slash" scale="2" class="text-blue" />
								</button>
								</div>
								<button class="reject_btn" type="button" @click="toggleCall">
									<v-icon name="phone" scale="2" class="text-blue" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- </movable> -->
		</div>
</template>

<script>
	// import { db } from 'src/db'
	import { mapState } from 'vuex'
	import { Device } from 'twilio-client';
	import axios from "axios";

	export default {
		name: "Call",
		props: {
			error: String,
			callData:{}
		},
		computed: {
			...mapState('globals', ['activeProsp']),
			...mapState('firebase', ['prospects','user']),
		},
		methods: {
            // Handle muting
			toggleMute() {
				this.muted = !this.muted;
				Device.activeConnection().mute(this.muted);
			},
			toggleCall: function() {
				if (!this.onPhone) {
					this.muted = false;
					this.onPhone = true;
					// make outbound call with current number
					// var n = '+' + this.countryCode + this.currentNumber.replace(/\D/g, '');
					this.connection = Device.connect({ number: this.callData.ProspNumber,callerID:this.user.Twilio });
					this.callStartTime = Date.now();
					localStorage.setItem('Direction',this.connection._direction);
					//eslint-disable-next-line
					console.log(this.connection);
					let prosp = this.prospects.find(prosp => prosp.id == this.activeProsp);
					// let newCallList = [];
					// if (prosp.Calls) {
					// 	newCallList = prosp.Calls;
					// }
					// newCallList.push({
					// 		DateTime:Date.now(),
					// 		Direction:'Outgoing',
					// 		Duration:'',
					// 		Status:'Completed',
					// });
					// db.doc(`Users/${this.user.id}/Prospects/${prosp.id}`).update({Calls:newCallList});
					this.connection.on('disconnect', () => {
						//eslint-disable-next-line
						console.log('Call Info:', this.connection);
						const callDuration = (Date.now() - this.callStartTime)/1000;
						localStorage.setItem('callDuration',callDuration);
						if (this.onPhone) {
							this.onPhone = false;
							this.muted = false;
							let callData = {
								From: this.user.Twilio,
								ProspectID: prosp.id,
								Uid: this.user.Uid,
								To: this.callData.ProspNumber
							};
							//eslint-disable-next-line
							console.log('callData', callData);
							axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/CallsPhones", callData);
							this.$bvModal.show('CallModal');
							this.$emit('hangupCall', false);
						}
					});
					// setTimeout(() => {
					// 	this.toggleCall()
					// }, 3600000);
				} else {
					// hang up call in progress 
					Device.disconnectAll();
					this.$emit('hangupCall',false);
					// this.$bvModal.hide('DailerModal');
				}
			},
		},
		data() {
            return {
				token:'',
				muted: false,
				onPhone: false,
				log: 'Connecting...',
				connection: null,
				callStartTime:null
            }
        },
		created() {
			this.toggleCall()
		}
	}
</script>

<style scoped>
</style>